export const BEFORE =
  "https://static.prod-images.emergentagent.com/jobs/2ce4e414-33fd-4f8e-8f51-014294dee4e4/images/395975bbd7caba931ab0da824aebdd75d70ba6c8abad1d3e63e683d74fb919ac.jpeg";

export const TABS = [
  {
    key: "victorian",
    label: "Victorian / Coquette",
    before:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/mnch3hck_thenewblack-5b5b88e6-5ffe-4d75-9338-9b2d53377e31.jpg",
    after:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/c436to6b_thenewblack-27aeb398-a9e8-4ce9-bb96-042c1fd84c5b.jpg",
    aspect: "9 / 16",
    copy: "Ruffled lace, high necklines, bows and romantic silhouettes. One of the most tender corners of the archive — pin-tucked bodices and floor-sweeping skirts, restyled onto you.",
  },
  {
    key: "prairie",
    label: "Prairie / Retro",
    before:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/nbke2n2d_thenewblack-5b5b88e6-5ffe-4d75-9338-9b2d53377e31%20%281%29.jpg",
    after:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/c1rgvoho_thenewblack-7388fe66-d453-4ed5-9e6e-3291de1ba6a4.webp",
    aspect: "9 / 16",
    copy: "Soft florals, billowing sleeves, sequins and sun-warmed cottons from the seventies. Easy, nostalgic pieces made to be lived in and worn out — and now, tried on virtually.",
  },
  {
    key: "wedding",
    label: "Wedding",
    before:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/a6bzmmmk_thenewblack-32de5c71-c5af-4cf7-a81a-1df2e85e0f2e.jpg",
    after:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_vintage-you/artifacts/cm12ato2_thenewblack-11caf87e-ecf6-4148-875b-6c459c56cc70%20%281%29.jpg",
    aspect: "9 / 16",
    copy: "Curious whether a vintage wedding dress is the look you want on your special day? This is the perfect place to explore. Try on timeless silhouettes and heirloom fabrics virtually to see what truly feels like you.",
  },
  {
    key: "custom",
    label: "Create Your Own Design",
    after:
      "https://static.prod-images.emergentagent.com/jobs/2ce4e414-33fd-4f8e-8f51-014294dee4e4/images/c3814682526d8cd263288219c6ff8e31e4170d5adabc9d206c50170c3b7e598e.jpeg",
    copy: "Describe a silhouette, an era, a fabric or a feeling — and we render a one-of-a-kind vintage piece, fitted to you. Your imagination, tailored.",
  },
];

export const getTab = (key) => TABS.find((t) => t.key === key);

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Canonical share URL is the backend OG endpoint so chat apps render a rich
// image card; it redirects humans to the in-app preview page.
export const lookShareUrl = (key) => `${BACKEND}/api/look/${key}`;

export function shareLook(key, label) {
  const url = lookShareUrl(key);
  const text = `I'm loving this ${label} look from Vintage Identity — virtual try-on launching December 2026. Join the waitlist:`;
  if (navigator.share) {
    return navigator
      .share({ title: "Vintage Identity", text, url })
      .then(() => ({ shared: true }))
      .catch(() => ({ shared: false }));
  }
  return navigator.clipboard
    .writeText(url)
    .then(() => ({ copied: true }))
    .catch(() => ({ copied: false, url }));
}
